import React, { Component } from "react";
import _ from "lodash";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import PubSub from "pubsub-js";

import { connect as reduxConnect } from "react-redux";
import { GlobalContext } from "@common/store/context";

import RouterManager from "@common/components/routerManager/routerManager.component";

import { mapActions, mapSelectors } from "@common/store/helpers/mapReducers";

class BaseComponent extends Component {
  constructor(props, DDados) {
    super(props);

    if (DDados) {
      this.DDados = DDados;
      this.initialDDados = _.cloneDeep(DDados);
    }
    this.componentDDadosMount();
  }

  initialState() {
    return {};
  }

  componentDDadosMount() {}

  componentDidMount() {}

  getDDados() {
    return this.DDados;
  }

  getInitialDDados() {}

  reload() {
    this.DDados = _.cloneDeep(this.initialDDados);
    store.dispatch({ type: commonActionType.RESET });
    PubSub.publish(commonActionType.RESET);
    this.componentDDadosMount();
    this.componentDidMount();
  }

  setDDados(key, props) {
    const setKey = keyValue => {
      this.DDados.Campos[keyValue] = _.merge(this.DDados.Campos[keyValue], props);
    };
    if (_.isArray(key)) {
      key.forEach(setKey);
    } else {
      setKey(key);
    }
  }
}

function connect(mappers) {
  const { actions, selectors } = mappers || {};
  return function(WrappedComponent) {
    class WithRouterComponent extends React.Component {
      constructor(props, context) {
        super(props, context);
      }
      render() {
        return <RouterManager>{manager => <WrappedComponent {...this.props} routerManager={manager} />}</RouterManager>;
      }
    }

    const connectedComponent =
      actions || selectors
        ? reduxConnect(mapSelectors(selectors), mapActions(actions), null, GlobalContext)(WithRouterComponent)
        : WithRouterComponent;

    return connectedComponent;
  };
}

export { connect };

export default BaseComponent;
